import React, { useState } from 'react';
import { Modal, Button, Spinner, Container, Row, Col } from 'react-bootstrap';
import bg2 from '../../assets/bg-2.svg';
import boxImg from '../../assets/box-img.webp';
import EmailService from "../../service/EmailService";

const Footer = () => {

  const [formData, setFormData] = useState({
    name: 'Newsletter Subscription',
    email: '',
    phone: '0000000000',
    formMessage: '',
  });
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', variant: '' });

    const currentTimestamp = new Date().toISOString();
    const subscriptionMessage = `Newsletter subscription request from Mechanichunt.com at : ${currentTimestamp}`;

    try {
      const response = await EmailService.sendEmail({ ...formData, formMessage: subscriptionMessage });
      setMessage({ text: response, variant: 'success' });
      setFormData({ name: 'Newsletter Subscription', email: '', phone: '0000000000', formMessage: '' });
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (<>

    <footer className="text-white">
      <Container>
          <Row className='justify-content-center'>
          <Col className='foot_text my-md-4 my-3' lg={3} md={6}>
            <h4>Company</h4>
            <ul>
              <li><a href="/" className="text-white">Home</a></li>
              <li><a href="/plans" className="text-white">Plans</a></li>
              <li><a href="/about" className="text-white">About Us</a></li>
              <li><a href="/contact" className="text-white">Contact Us</a></li>
            </ul>
          </Col>

          <Col className='foot_text my-md-4 my-3' lg={3} md={6}>
            <h4>Useful Links</h4>
            <ul>
              <li><a href="/blogs" className="text-white">Blog</a></li>
              <li><a href="/privacypolicy" className="text-white">Privacy Policy</a></li>
              <li><a href="/termsandcondition" className="text-white">Terms & Conditions</a></li>
              <li><a href="/refundandcancellation" className="text-white">Refund & Cancellation</a></li>
            </ul>
          </Col>

          <Col className='contact-detail my-md-4 my-3' lg={3} md={6}>
          <h4>Contact Info</h4>
          <ul className="contact-list">
            <li><a href="tel:+18008057820"><i className="fa fa-phone" title="Phone"></i> +1 (800) 805-7820</a></li>
            <li><a href="mailto:mechanichunt@gmail.com"><i className="fa fa-envelope" title="Email"></i> mechanichunt@gmail.com</a></li>
          </ul>

          </Col>

          <Col className='social-icon my-md-4 my-3' lg={3} md={6}>
          <h4>Social Links</h4>
          <ul>
          <li><a href="https://www.facebook.com/mechanichunt/" target="_blank"><i className="fab fa-facebook-square" title="facebook"></i></a></li>
          <li><a href="https://www.instagram.com/mechanichunt_/" target="_blank"><i className="fab fa-instagram" title="instagram"></i></a></li>
          <li><a href="https://x.com/mechanichunt" target="_blank"><i className="fab fa-x-twitter" title="twitter"></i></a></li>
          <li><a href="https://www.pinterest.com/mechanichunt/" target="_blank"><i className="fab fa-pinterest" title="pinterest"></i></a></li>
          <li><a href="https://www.youtube.com/@MechanicHunt" target="_blank"><i className="fab fa-youtube" title="youtube"></i></a></li>
          </ul>
          </Col>
          <Col md={12}>
          <hr/>
          </Col>

          <Col md={12} className="text-center mt-2 copy-right">
            <p>&copy; 2022- {new Date().getFullYear()} Mechanic Hunt. All Rights Reserved. Powered By Breakdown Inc</p>
          </Col>

        </Row>

      </Container>
    </footer>

    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className='py-2' closeButton>
          <Modal.Title><strong>{message.variant === 'success' ? 'Subscribed Successfully!' : 'Error'}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center my-md-3">
          {message.variant === 'success' ? (
            <>
              <p className="text-success mb-0">😊 Thank you for subscribing! </p>
            </>
          ) : (
            <>
              <p className="text-danger mb-0">❌ {message.text}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Footer;
